import { type ExtractPropTypes, type PropType, defineComponent } from 'vue'
import {
  createNamespace,
  getSizeStyle,
  makeStringProp,
} from '@xzx-design/utils'
import {
  renderEmpty,
  renderLoss,
  renderNetwork,
  renderNoPermission,
  renderNoSignal,
  renderNotFound,
  renderSystem,
} from './svgs'

import type { EmptyImageTypes } from './types'
import type { Numeric } from '@xzx-design/utils'

const [name, bem] = createNamespace('empty')

export const emptyProps = {
  image: makeStringProp<EmptyImageTypes>('default'),
  imageSize: [Number, String, Array] as PropType<Numeric | [Numeric, Numeric]>,
  description: String,
}

export type EmptyProps = ExtractPropTypes<typeof emptyProps>

export default defineComponent({
  name,

  props: emptyProps,

  setup(props, { slots }) {
    const renderDescription = () => {
      const description = slots.description
        ? slots.description()
        : props.description

      if (description) {
        return <p class={bem('description')}>{description}</p>
      }
    }

    const renderBottom = () => {
      if (slots.default) {
        return <div class={bem('bottom')}>{slots.default()}</div>
      }
    }

    const renderImage = () => {
      if (slots.image) {
        return slots.image()
      }

      const PRESET_IMAGES: Record<EmptyImageTypes, () => JSX.Element> = {
        network: renderNetwork,
        system: renderSystem,
        loss: renderLoss,
        404: renderNotFound,
        'no-permission': renderNoPermission,
        'no-signal': renderNoSignal,
        empty: renderEmpty,
        default: renderEmpty,
      }

      return PRESET_IMAGES[props.image]?.() || <img src={props.image} />
    }

    return () => (
      <div class={bem()}>
        <div class={bem('image')} style={getSizeStyle(props.imageSize)}>
          {renderImage()}
        </div>
        {renderDescription()}
        {renderBottom()}
      </div>
    )
  },
})
